export default __webpack_public_path__ + "static/media/occamx-bg-2x.9dcedb54.jpg";